import type { GroupByOptions, ResultDto } from "types/Result";
import { action } from "typesafe-actions";
import { ReportCommentsActionTypes } from "./types";

// get shared report
export const getSharedReportCommentsRequest = (
	accessToken: string,
	requestId: string,
	resultId: string,
	segmentPath: string | null,
	groupBy: GroupByOptions,
	limit?: number,
	skip?: number,
) =>
	action(ReportCommentsActionTypes.GET_SHARED_REPORT_COMMENTS_REQUEST, {
		accessToken,
		requestId,
		resultId,
		segmentPath,
		limit,
		skip,
		groupBy,
	});

// get
export const getReportCommentsRequest = (
	requestId: string,
	resultId: string,
	organizationId: string,
	reportId: string,
	segmentPath: string | null,
	groupBy: GroupByOptions,
	limit?: number,
	skip?: number,
) =>
	action(ReportCommentsActionTypes.GET_REPORT_COMMENTS_REQUEST, {
		requestId,
		resultId,
		organizationId,
		reportId,
		segmentPath,
		limit,
		skip,
		groupBy,
	});
export const getReportCommentsError = (requestId: string, error: Error) =>
	action(ReportCommentsActionTypes.GET_REPORT_COMMENTS_ERROR, {
		requestId,
		error,
	});
export const getReportCommentsSuccess = (
	requestId: string,
	segmentPath: string,
	result: ResultDto,
) =>
	action(ReportCommentsActionTypes.GET_REPORT_COMMENTS_SUCCESS, {
		requestId,
		segmentPath,
		result,
	});
